export default __webpack_public_path__ + "static/media/tvinsurecovid.de8ba1be.png";